<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="50%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="名称" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="图片" prop="icon">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/admin/upload_img"
            name="img"
            :show-file-list="false"
            :on-success="handleSuccess">
            <img v-if="picUrl" :src="picUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
      <el-form-item label="来源" prop="source_id">
        <el-select v-model="formData.source_id" placeholder="请选择来源" @change="getAuthorList" filterable>
          <el-option :key="0" label="请选择来源" :value="formData.source_id"></el-option>
          <el-option v-for="item in sourceList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="作者" prop="author_id">
        <el-select v-model="formData.author_id" placeholder="请选择作者" filterable>
          <el-option :key="0" label="请选择作者" :value="formData.author_id"></el-option>
          <el-option v-for="item in authorList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="栏目" prop="group_id">
        <el-select v-model="formData.group_id" placeholder="请选择栏目" filterable>
          <el-option :key="0" label="请选择栏目" :value="formData.group_id"></el-option>
          <el-option v-for="item in groupList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布时间" prop="publish_time">
        <el-date-picker
          v-model="formData.publish_time"
          type="datetime"
          value-format="timestamp"
          placeholder="发布时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="排序值" prop="sort_num">
        <el-input-number v-model="formData.sort_num" :min="0" :max="65535"></el-input-number>
      </el-form-item>
      <el-form-item label="简介" prop="intro">
        <el-input v-model="formData.intro" type="textarea" :rows="3"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'handpick_category_add',
  props: [
    'visible', 'id', 'sourceList', 'groupList'
  ],
  data () {
    return {
      title: '添加专辑',
      formData: {
        title: '',
        pic: '',
        intro: '',
        group_id: 0,
        source_id: 0,
        author_id: 0,
        sort_num: 0,
        publish_time: 0
      },
      picUrl: '',
      authorList: [],
      addFormRules: {
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.picUrl = ''
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑专辑'
        this.getCategoryInfo(this.id)
      }
      if (this.formData.publish_time === 0) {
        this.formData.publish_time = new Date().getTime()
      }
    },
    async getCategoryInfo (id) {
      const res = await this.$http.get('/admin/handpick_category/info/' + id)
      if (res.code === 0) {
        this.formData = {
          title: res.data.title,
          pic: res.data.pic,
          intro: res.data.intro,
          group_id: res.data.group_id,
          source_id: res.data.source_id,
          author_id: res.data.author_id,
          sort_num: res.data.sort_num,
          publish_time: res.data.publish_time
        }
        this.picUrl = res.data.pic_url
        this.getAuthorList()
      }
    },
    async getAuthorList () {
      const res = await this.$http.get('/admin/handpick_author/select_list', {
        source_id: this.formData.source_id
      })
      if (res.code === 0) {
        this.authorList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSuccess (resp, file, fileList) {
      if (resp.code === 0) {
        this.picUrl = resp.data.url
        this.formData.pic = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    }
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
